import { useEffect, useMemo } from 'react';

import { observer } from 'mobx-react';
import { I18nextProvider } from 'react-i18next';

import i18n from '../i18n/config';
import { getUserLanguage } from '../i18n/helpers';
import { firebaseAuth } from '../services/firebase';
import { useStores } from '../stores/useStores';

export const LocaleProvider: React.FC<React.PropsWithChildren> = observer(function LocaleProvider({ children }) {
  const { userStore } = useStores();
  const { language } = userStore.profile || {};

  const locale = useMemo(() => getUserLanguage(language), [language]);

  useEffect(() => {
    const lowerCaseLocale = locale.toLowerCase();
    void i18n.changeLanguage(locale);
    firebaseAuth.languageCode = lowerCaseLocale;
    document.documentElement.lang = lowerCaseLocale;
  }, [locale]);

  return <I18nextProvider i18n={i18n}>{children}</I18nextProvider>;
});
